var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-page mt-8"},[_c('h1',[_vm._v("Error 404")]),_c('p',[_vm._v("Oops! Page not found.")])])
}]

export { render, staticRenderFns }